import React from "react"
import { useQuery } from "@tanstack/react-query"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { StatsCard } from "@/components/stats-card"
import { api } from "@/lib/api"
import { Timer, Activity, Clock, Zap } from "lucide-react"

export default function LatencyPage() {
  const { data: realtime, isLoading } = useQuery({
    queryKey: ["realtime-stats"],
    queryFn: () => api.getRealtimeStats(),
    refetchInterval: 5000,
  })

  const stats = realtime?.data || {}

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Latency Monitor</h1>
        <p className="text-muted-foreground">API response time monitoring</p>
      </div>

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        <StatsCard title="Avg Latency" value={`${stats.avg_latency || 0}ms`} icon={Clock} accent="brand" />
        <StatsCard title="P95 Latency" value={`${stats.p95_latency || 0}ms`} icon={Timer} accent="warning" />
        <StatsCard title="Requests/min" value={stats.requests_per_min || 0} icon={Activity} accent="info" />
        <StatsCard title="Error Rate" value={`${stats.error_rate || 0}%`} icon={Zap} accent="error" />
      </div>

      <div className="grid gap-4 md:grid-cols-2">
        <Card>
          <CardHeader>
            <CardTitle>Active Connections</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="text-3xl font-bold">{stats.active_connections || 0}</div>
            <p className="text-sm text-muted-foreground">Currently active</p>
          </CardContent>
        </Card>
        <Card>
          <CardHeader>
            <CardTitle>Uptime</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="text-3xl font-bold">{stats.uptime || "0h 0m"}</div>
            <p className="text-sm text-muted-foreground">System uptime</p>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
